import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  static DOMAIN:string = '';
  static internalCache:any = '';

  static set token(value:any){
    localStorage.setItem('token', JSON.stringify(value));
  }
  static get token(){
    return JSON.parse(localStorage.getItem('token'));
  }

  static set user(value:any){
    localStorage.setItem('user', JSON.stringify(value));
  }
  static get user(){
    return JSON.parse(localStorage.getItem('user'));
  }

  static set rememberMe(value:any){
    localStorage.setItem('rememberMe', value);
  }
  static get rememberMe(){
    return localStorage.getItem('rememberMe');
  }

  static logout(){
     AppComponent.token = '';
     AppComponent.user = '';
     AppComponent.rememberMe = false;
  }

  constructor() {
     if (window.location.origin.indexOf('localhost') > 0){
       // AppComponent.DOMAIN = 'http://sxfaureciaalertas-staging.azurewebsites.net';
       AppComponent.DOMAIN = 'https://alertas-qa.faurecia.com.br';
     } else if (AppComponent.DOMAIN == '') {
         AppComponent.DOMAIN = window.location.origin;
     }     
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts